import { startOfWeek, startOfDay, addDays } from 'date-fns';
import { wholeDayInSeconds } from 'helpers/timeConsts';
import { ScheduleRange } from 'store/scheduleRanges/interfaces';

export interface PreviewScheduleRange {
  id: string;
  '@id': string;
  startDate: Date;
  endDate: Date;
  day: number;
  schedule: string;
  timeFrom: number;
  timeTo: number;
}

interface ConvertScheduleRangesParams {
  scheduleRanges: ScheduleRange[];
  isRegularWeek: boolean;
}

export default function convertScheduleRanges({
  scheduleRanges,
  isRegularWeek,
}: ConvertScheduleRangesParams) {
  return scheduleRanges.map((scheduleRange) => {
    const { timeFrom, timeTo, day, schedule } = scheduleRange;

    let startDate = isRegularWeek
      ? startOfWeek(new Date())
      : startOfDay(new Date());
    let endDate = isRegularWeek
      ? startOfWeek(new Date())
      : startOfDay(new Date());

    startDate = addDays(startDate, isRegularWeek ? day : day - 1);
    startDate.setSeconds(timeFrom);

    endDate = addDays(endDate, isRegularWeek ? day : day - 1);
    if (timeTo === wholeDayInSeconds) {
      endDate.setHours(23, 59, 59, 999);
    } else {
      endDate.setSeconds(timeTo);
    }

    return {
      id: scheduleRange.id,
      '@id': scheduleRange['@id'],
      startDate,
      endDate,
      day,
      schedule,
      timeTo,
      timeFrom,
    };
  });
}
